import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('negociacao', 'historico-vendas');

const historicoVendasActions = {
  vlrHistoricoExtensoes: { method: 'GET', url: `${basePath}/vlr-historico/extensoes{?idExtensao*}` },
  vlrHistoricoProduto: { method: 'GET', url: `${basePath}/vlr-historico/produto/{idProduto}` },
  vlrHistoricoTipoAcordoExtensoes: { method: 'GET', url: `${basePath}/vlr-historico/{tipoAcordo}/extensoes{?idExtensao*}` },
  vlrHistoricoTipoAcordoProduto: { method: 'GET', url: `${basePath}/vlr-historico/{tipoAcordo}/produto/{idProduto}` },
};

export default resource => resource(`${basePath}`, {}, historicoVendasActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/negociacao/historico-vendas.js